exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumb:hover .ytp-large-play-button-bg[data-v-4abc37ac] {\n  transition: fill 0.1s cubic-bezier(0, 0, 0.2, 1), fill-opacity 0.1s cubic-bezier(0, 0, 0.2, 1);\n  fill: #f00;\n  fill-opacity: 1;\n}", ""]);

// exports
